<div class="label-section" [ngClass]="{ 'input-disabled': isDisabled }">
  <label [for]="forId">
    {{ label }}
  </label>
  @if (!isRequired && !isDisabled) {
    <span>Frivillig</span>
  }
  @if (showIsRequiredError) {
    <span class="error-text required-text">*Påkrevd</span>
  }
  @if (labelHelpText) {
    <span class="label-help-text" [ngClass]="{ 'error-text': isErrorState }">
      {{ labelHelpText }}
    </span>
  }
</div>
<div class="input-section">
  @if (!!prefixIcon) {
    <mat-icon class="prefix-icon" [svgIcon]="prefixIcon" />
  }
  <input
    #inputElement
    autocomplete="off"
    [attr.data-testid]="textTestId()"
    [formControl]="control"
    [id]="forId"
    [mask]="mask()"
    [maxlength]="maxLength"
    [minlength]="minLength"
    [ngClass]="{ 'has-error': isErrorState, 'prefix-icon': !!prefixIcon, 'suffix-icon': !!suffixIcon }"
    [placeholder]="placeholder"
    [readOnly]="readonly"
    [type]="type"
    (blur)="blurEvent.emit()"
    (focus)="onFocus($event)"
  />
  @if (!!suffixIcon) {
    <app-ice-icon-button
      class="suffix-icon"
      [iconName]="suffixIcon"
      [testId]="buttonTestId()"
      (clicked)="onSuffixIconClicked()"
    />
  }
</div>
@if (isErrorState && !!errorText && !showIsRequiredError) {
  <div class="error-section">
    <mat-icon [svgIcon]="IconNames.ice_warning" />
    <span>{{ errorText }}</span>
  </div>
} @else if (!!longHelpText) {
  <div class="long-help-text">{{ longHelpText }}</div>
}
